import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import tw from "tailwind-styled-components";
import { useChildIndex } from "../../hooks";
import STooltip from "../../Tooltip";
const PropertyButtonContainer = tw.div`
  flex
  justify-center
  items-center
  grow
  border
  border-white
  border-opacity-10
  rounded-md
  py-[6px]
  text-xs
  cursor-pointer

  ${({ $selection })=>{
    return $selection ? $selection === "literal" ? "bg-brand-primary bg-opacity-10 text-brand-primary hover:border-opacity-20" : $selection === "conditional" ? "bg-purple-500 bg-opacity-10 text-purple-500 hover:border-opacity-20" : "bg-grayscale-light hover:border-opacity-30 text-white" : "bg-grayscale-light hover:border-opacity-30 text-white";
}}
`;
const PropertyButton = ({ icon, label, value, onClick, selection, showTooltip = true, grow = true })=>{
    const ref = React.useRef(null);
    const { isFirst, isLast } = useChildIndex(ref) || {};
    return /*#__PURE__*/ _jsxs("div", {
        className: grow ? "grow" : "",
        ref: ref,
        children: [
            showTooltip && /*#__PURE__*/ _jsx(STooltip, {
                size: "xs",
                placement: isFirst ? "top-start" : isLast ? "top-end" : "top",
                content: typeof value !== "string" ? label : label || value,
                children: /*#__PURE__*/ _jsx(PropertyButtonContainer, {
                    ref: ref,
                    onClick: ()=>onClick(value),
                    $selection: selection,
                    children: typeof icon === "function" ? icon({
                        value
                    }) : icon
                })
            }),
            !showTooltip && /*#__PURE__*/ _jsx(PropertyButtonContainer, {
                ref: ref,
                onClick: ()=>onClick(value),
                $selection: selection,
                children: typeof icon === "function" ? icon({
                    value
                }) : icon
            })
        ]
    });
};
export default PropertyButton;
